import { AxiosError } from '@price-for-profit/micro-services';
import { useSnackbar } from 'notistack';
import { QueryKey, useMutation, useQueryClient } from 'react-query';
import { MUTATION_KEYS, QUERY_KEYS } from 'shared/constants';
import { useService } from 'shared/providers';
import { AcceptProductProps } from 'shared/service';
import { CommoditySqlView } from 'shared/types';

export function useAcceptProducts() {
  const { productService } = useService();
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();
  const mutation = useMutation<
    CommoditySqlView[],
    Error | AxiosError,
    AcceptProductProps,
    { previousData: [QueryKey, CommoditySqlView[]][] }
  >(request => productService.acceptProducts(request), {
    mutationKey: MUTATION_KEYS.massAcceptProduct,
    onSuccess: (_, { ids }) => {
      enqueueSnackbar(`${ids.length} products accepted successfully`, { variant: 'success' });
      queryClient.invalidateQueries([QUERY_KEYS.commodities]);
    },
    onError: () => {
      enqueueSnackbar('There was a problem accepting products', { variant: 'error' });
    },
  });

  return mutation;
}
